import {
  settingNoticeGet,
  settingNoticeEdit,
  settingLinkList,
  settingLinkEdit,
  settingFinalLinkList,
  settingFinalLinkEdit,
  settingGet,
  settingSet,
} from '@/api/setting'

export default {
  async settingNoticeGet({ }, data) {
    return settingNoticeGet(data)
  },
  async settingNoticeEdit({ }, data) {
    return settingNoticeEdit(data)
  },
  async settingLinkList({ }, data) {
    return settingLinkList(data)
  },
  async settingLinkEdit({ }, data) {
    return settingLinkEdit(data)
  },
  async settingFinalLinkList({ }, data) {
    return settingFinalLinkList(data)
  },
  async settingFinalLinkEdit({ }, data) {
    return settingFinalLinkEdit(data)
  },
  async settingGet({ }, data) {
    return settingGet(data)
  },
  async settingSet({ }, data) {
    return settingSet(data)
  },
}
